import SiteLoader from "./SiteLoader";
import SiteTransition from "./SiteTransition";

export default [new SiteLoader(), new SiteTransition()];
